export default __webpack_public_path__ + "static/media/bilim.25db86a5.svg";